
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { LeadForm } from "./LeadForm";
import { useState } from "react";
import { LeadDetailsView } from "./details/LeadDetailsView";
import { LeadDetailsHeader } from "./details/LeadDetailsHeader";
import { ScrollArea } from "@/components/ui/scroll-area";

interface LeadDetailsDialogProps {
  lead: any;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUpdate?: () => void;
}

export const LeadDetailsDialog = ({ 
  lead, 
  open, 
  onOpenChange, 
  onUpdate 
}: LeadDetailsDialogProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setIsEditing(false);
    }
    onOpenChange(newOpen);
  };

  if (!lead) {
    return (
      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogContent>
          <LeadDetailsHeader
            title="No lead selected"
            isEditing={false}
            onEdit={() => {}}
          />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-3xl h-[80vh]">
        <LeadDetailsHeader
          title={isEditing ? "Edit Lead" : lead.name}
          isEditing={isEditing}
          onEdit={() => setIsEditing(true)}
        />

        <ScrollArea className="h-[calc(80vh-6rem)] pr-4">
          {isEditing ? (
            <LeadForm
              initialData={lead}
              onSuccess={() => {
                setIsEditing(false);
                onUpdate?.();
              }}
              onCancel={() => setIsEditing(false)}
            />
          ) : (
            <LeadDetailsView lead={lead} />
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
